import { render, staticRenderFns } from "./paymentOkPage.vue?vue&type=template&id=2c1ac3e8"
import script from "./paymentOkPage.vue?vue&type=script&lang=ts"
export * from "./paymentOkPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports